try { window.$ = window.jQuery = require('jquery'); }
catch (e) {}

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
}

!function ($) {
  $(document).ready(function() {

    // *************************
    // Disable the ckeditor image uploader button
    // *************************
    $(document).on('click', '.ck-file-dialog-button', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      $(this).closest(".ck-splitbutton").find('button.ck-splitbutton__arrow').click();
    });
    $(document).on('click', '.ck-file-dialog-button > button', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    });

    // *************************
    // Show/Hide elements on hover
    // *************************
    $(document).on('mouseenter', '.astp', function (e) { $(this).parent().find("._d-none").stop().fadeIn(); });
    $(document).on('mouseleave', '.astp', function (e) { $(this).parent().find("._d-none").stop().fadeOut(); });


  });
}(window.jQuery);
